module.exports = __webpack_public_path__ + "img/whatsapp.53bda33e.svg";